/**
 * UserListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
} from 'components';
import { Button, Checkbox, DatePicker, Input, Select, Radio } from 'antd';
import moment from 'moment';

const UserListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '회원구분',
      form: [
        {
          input: (
            <Radio.Group value={'주문회원'}>
              <Radio value={'주문 회원'}>주문 회원</Radio>
              <Radio value={'주문 안한 회원'}>주문 안한 회원</Radio>
              <Radio value={'특별관리회원'}>특별관리회원</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '검색어',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'아이디'}
              options={[
                { label: '아이디', value: '아이디' },
                { label: '회원명', value: '회원명' },
                { label: '전화번호', value: '전화번호' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              placeholder="검색어를 입력해주세요"
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '회원가입일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '가입유형',
      form: [
        { input: <Checkbox>일반 회원</Checkbox> },
        { input: <Checkbox>연동 아이디 회원</Checkbox> },
        {
          input: (
            <>
              <Checkbox>간편로그인 회원</Checkbox>
              (&nbsp;&nbsp;
              <Checkbox.Group options={['네이버', '카카오', '구글']} />)
            </>
          ),
        },
      ],
    },
    {
      label: '회원상태',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '회원등급',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '적립금',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large, marginRight: 0 }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
              />
              <p style={{ ...styles.form.text, marginLeft: 8 }}>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '상세검색',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 100; i++) {
    newData.push({
      created_at: new Date(),
      name: `홍길동 ${i}`,
      account: `abcdefg${i}`,
      grade: 'VVIP',
      gender: 'M',
      age: 25,
      area: '부산광역시 어쩌고 저쩌고 이렇고 저렇고',
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>회원 목록</Title>

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              // data={newData}
              columns={[
                {
                  title: '이름',
                  key: 'name',
                },
                {
                  title: '아이디',
                  key: 'account',
                },
                {
                  title: '등급',
                  key: 'grade',
                },
                {
                  title: '성별',
                  key: 'gender',
                },
                {
                  title: '나이',
                  key: 'age',
                },
                {
                  title: '지역',
                  key: 'area',
                  width: 300,
                },
                {
                  title: '회원가입일',
                  key: 'created_at',
                  render: (item) => moment(item).format('YYYY-MM-DD'),
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default UserListPresenter;
